/**
 * typography for theme
 */
const typography = Object.freeze({
  fontFamily: "'Poppins', sans-serif",
  fontSize: 14,
})

export default typography
